<script setup lang="ts">
  import type { EmailSenderProvider } from '@stuut/api/models';
  import GoogleLogo from '@ui/assets/google-logo.svg?component';
  import MicrosoftLogo from '@ui/assets/microsoft-logo-colored.svg?component';
  import SendgridLogo from '@ui/assets/sendgrid-logo.svg?component';

  interface Props {
    provider?: EmailSenderProvider | null;
    size?: string;
  }

  defineProps<Props>();
</script>

<template>
  <div class="w-8 flex">
    <i v-if="!provider" class="fa fa-envelope mx-auto" />

    <GoogleLogo
      v-else-if="provider === 'google'"
      class="mx-auto"
      :class="{
        'h-7': !size || size !== 'sm',
        'w-7': !size || size !== 'sm',
        'w-6': size === 'sm',
        'h-6': size === 'sm',
      }"
    />

    <MicrosoftLogo v-else-if="provider === 'microsoft'" class="h-7 w-7 mx-auto" />

    <SendgridLogo v-else class="h-5 w-5 mx-auto" />
  </div>
</template>

<style scoped></style>
